import { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function SectionDescriptionHint({ description, isMobile, darkMode = false }) {
  const [anchorEl, setAnchorEl] = useState(null);

  if (!description) {
    return null;
  }

  const handleToggleMobileHelp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl((currentValue) => (currentValue ? null : event.currentTarget));
  };

  const handleCloseMobileHelp = () => {
    setAnchorEl(null);
  };

  const iconButtonSx = {
    width: 0,
    height: 0,
    color: darkMode ? "rgba(226, 232, 240, 0.72)" : "rgba(52, 71, 103, 0.52)",
    "&:hover": {
      color: darkMode ? "#93c5fd" : ({ palette: { info } }) => info.main,
      backgroundColor: darkMode ? "rgba(96, 165, 250, 0.14)" : "rgba(26, 115, 232, 0.08)",
    },
    fontSize: 15
  };

  if (isMobile) {
    return (
      <>
        <IconButton
          size="small"
          aria-label="Ver descrição da seção"
          onClick={handleToggleMobileHelp}
          sx={iconButtonSx}
        >
          <Icon sx={{ fontSize: 18 }}>help_outline</Icon>
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseMobileHelp}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              mt: 1,
              maxWidth: 280,
              borderRadius: "14px",
              boxShadow: "0 18px 48px rgba(15, 23, 42, 0.18)",
              border: darkMode
                ? "1px solid rgba(148, 163, 184, 0.18)"
                : "1px solid rgba(148, 163, 184, 0.14)",
              backgroundColor: darkMode ? "#142033" : "#ffffff",
            },
          }}
        >
          <MDBox px={1.5} py={1.25}>
            <MDTypography
              variant="caption"
              sx={{
                display: "block",
                lineHeight: 1.6,
                color: darkMode ? "rgba(226, 232, 240, 0.86)" : "rgba(52, 71, 103, 0.86)",
              }}
            >
              {description}
            </MDTypography>
          </MDBox>
        </Popover>
      </>
    );
  }

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <MDTypography
          variant="caption"
          sx={{
            display: "block",
            lineHeight: 1.6,
            color: "#fff",
          }}
        >
          {description}
        </MDTypography>
      }
    >
      <IconButton size="small" aria-label="Ver descrição da seção" sx={iconButtonSx}>
        <Icon sx={{ fontSize: 18 }}>help_outline</Icon>
      </IconButton>
    </Tooltip>
  );
}

SectionDescriptionHint.propTypes = {
  description: PropTypes.string,
  isMobile: PropTypes.bool,
  darkMode: PropTypes.bool,
};

export default SectionDescriptionHint;
